import clienteAxios from "../services/axios"
import { authHeader } from "../helpers/auth-header"

export const searchService = {
	// basicSearch,
	savedSearchsList,
	deleteSearchesList,
	saveNewSearch,
}

// function basicSearch(searchTerm){
//    return clienteAxios.get('/datos',searchTerm, {"headers": authHeader()});
// }

function savedSearchsList() {
	return clienteAxios.get("/search", [], { headers: authHeader() })
}

function deleteSearchesList(searchId) {
	return clienteAxios.delete(`/search?search_id=${searchId}`, { headers: authHeader() })
}

function saveNewSearch(newSearch) {
	if (newSearch.id) {
		return clienteAxios.put("/search", newSearch, { headers: authHeader() })
	} else {
		return clienteAxios.post("/search", newSearch, { headers: authHeader() })
	}
}

function updateNewSearch(updateSearch) {
	return clienteAxios.post("/search", updateSearch, { headers: authHeader() })
}
